import { AnyAppEvent, AppEvent } from "../../appEvent.types";
import { z } from "zod";

const eventName = "open-event-socials" as const;

export const OpenEventSocialsEventDataSchema = z.object({
  eventId: z.string(),
});

export type OpenEventSocialsEventData = z.infer<
  typeof OpenEventSocialsEventDataSchema
>;

export type OpenEventSocialsEvent = AppEvent<
  typeof eventName,
  OpenEventSocialsEventData
>;

export const isOpenEventSocialsEvent = (
  event: AnyAppEvent
): event is OpenEventSocialsEvent => event.name === eventName;

export { eventName as openEventSocials };
